import { nodeTypeFactory } from '../../../../utils/schema';
export var CutNode;
(function (CutNode) {
    CutNode["Cut"] = "yfm_cut";
    CutNode["CutTitle"] = "yfm_cut_title";
    CutNode["CutContent"] = "yfm_cut_content";
})(CutNode || (CutNode = {}));
export const cutType = nodeTypeFactory(CutNode.Cut);
export const cutTitleType = nodeTypeFactory(CutNode.CutTitle);
export const cutContentType = nodeTypeFactory(CutNode.CutContent);
